module.exports = __webpack_public_path__ + "img/quizmayhem_banner_zoo.59069000.jpg";